module.exports = __webpack_public_path__ + "621bd386.svg";